<template>
    <div>
        <div class="columns">
            <div class="column is-2 margin-left bg-panel">
                <sidebar />
            </div>
            <div class="column router_view">
                <router-view></router-view>
            </div>
        </div>


        <buttonLine />
    </div>
</template>
<script>
import sidebar from '../components/panel/sidebar'
import buttonLine from '../components/common/theButtonLine'

export default {
    components: {
        sidebar,
        buttonLine,
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
            this.$router.push('/login')
        }
    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
.bg-panel {
    background-color: #656363;
    max-height: 100vh;
    @media screen and (max-width: 778px) {
        min-height: 10vh;
    }
}
.router_view{
    max-height: 100vh;
   overflow-y: auto;
}
</style>
